import { FormattedMessage } from 'react-intl'
import {
  BlockedItemsList,
  BlockedItemsListItem,
  BlockMoveMultipleItemsMessageContainer,
  MoveMultipleItemsMessage,
  TotaItems
} from './styled-components'
import { projectMenuItemTypeOptions } from '../../containers/project-menu/constants'

const BlockMoveMultipleItemsMessage = ({
  blockedItems = [],
  allowedItems = []
}) => {
  const totalBlockedItems = blockedItems.length
  const totalAllowedItems = allowedItems.length

  const getTypeText = (itemType) =>
    itemType === projectMenuItemTypeOptions.FOLDER ? 'folder' : 'project'

  return (
    <BlockMoveMultipleItemsMessageContainer>
      <TotaItems>
        <FormattedMessage
          id="item_cant_be_moved"
          values={{ count: totalBlockedItems }}
        />
      </TotaItems>
      <MoveMultipleItemsMessage>
        <FormattedMessage id="those_items_already_exist" />
        <BlockedItemsList>
          {blockedItems.map((item) => (
            <BlockedItemsListItem key={item.name}>
              <FormattedMessage id={getTypeText(item.itemType)} />
              {` `}
              {item.name}
            </BlockedItemsListItem>
          ))}
        </BlockedItemsList>
        <FormattedMessage
          id="remaning_item_was_moved"
          values={{ count: totalAllowedItems }}
        />
      </MoveMultipleItemsMessage>
    </BlockMoveMultipleItemsMessageContainer>
  )
}

export default BlockMoveMultipleItemsMessage
